<button
  [matMenuTriggerFor]="profileMenu"
  mat-icon-button
  role="button"
  [disabled]="viewAsStudent"
  matTooltip="User Options Menu"
  class="profile-button"
  aria-label="User Options Menu"
  aria-controls="profile-side-panel"
  >
  <span class="off-screen">User Options Menu</span>
  <profile-image
    [profileUrl]="userProfile?.profileUrl"
    [imgSize]="imgSize"
    altText="User Options Menu"
  ></profile-image>
</button>
<mat-menu
  #profileMenu="matMenu"
  xPosition="before"
  role="menu"
  class="user-options-menu"
  >
  <div fxLayout="column" id="profile-side-panel">
    <section class="header" fxLayout="row" fxLayoutAlign="center center">
      <profile-image
        [profileUrl]="userProfile?.profileUrl"
        altText="Profile Image"
        title="Profile Image"
        role="presentation"
      ></profile-image>
      <div fxLayout="column" class="user-info">
        <span class="user-name">{{ profileName }}</span>
      </div>
    </section>

    @if (timezoneMismatch) {
      <section
        class="timezone-container"
        fxFlex="100"
        fxLayout="row wrap"
        fxLayoutAlign="center center"
        >
        <div
          class="timezone-warning"
          fxFlex="100"
          fxLayoutAlign="center center"
          >
          <mat-icon class="warning-icon">warning</mat-icon> Dates/Times
          will display in your school's timezone.
        </div>
        <div fxFlex="100" fxLayoutAlign="center center" fxLayout="column">
          <p class="timezone-label">
            Local Timezone:
            <span class="timezone-value">{{
              localTimezoneDisplay
            }}</span>
          </p>
          <p class="timezone-label">
            School Timezone:
            <span class="timezone-value">{{ schoolTimezone }}</span>
          </p>
        </div>
      </section>
    }

    <mat-divider></mat-divider>

    <section
      class="edit-profile-menu-item profile-side-panel-item"
      fxLayoutAlign="space-around"
      >
      <button
        mat-menu-item
        color="primary"
        (click)="editProfile()"
        class="width-100perc mat-raised-button mat-button-base mat-primary"
        >
        Edit Profile
      </button>
    </section>

    <section
      class="profile-side-panel-item"
      fxLayout="column"
      fxLayoutAlign="center center"
      >
      <a
        mat-menu-item
        target="_blank"
        [href]="getHelpCenterUrl()"
        color="primary"
        class="width-100perc mat-raised-button mat-button-base mat-primary"
        >
        <mat-icon class="margin-right-5px color-white">help</mat-icon>
        <span>Help Center</span>
      </a>
    </section>

    <section
      class="profile-side-panel-item"
      fxLayout="column"
      fxLayoutAlign="center center"
      >
      <button
        mat-menu-item
        color="primary"
        (click)="logout()"
        class="width-100perc mat-raised-button mat-button-base mat-primary"
        >
        Logout
      </button>
    </section>
    <div class="profile-side-panel-version">
      <div>Client {{ frontendBuildNumber }} Api {{ apiBuildNumber }}</div>
    </div>
  </div>
</mat-menu>
